// 时间戳格式化，'{y}-{m}-{d} {h}:{i}:{s} {a}'[年月日 时分秒 星期x]
const parseTime = function(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s} {a}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a')
      return [
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
        '星期日',
      ][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
};

const formatTime = function(time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    );
  }
};

// 大于x显示x+，例如大于99显示99+
const moreThanN = function(val, max) {
  let _val = isNaN(val) ? 0 : Number(val);
  if (_val > max) {
    return max + '+';
  } else {
    return _val + '';
  }
};

// 格式化为千分位
const formatThousandth = function(val) {
  if (typeof val === 'number') {
    return (val + '').replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,');
  } else {
    return val;
  }
};

const bsFilters = {
  parseTime,
  formatTime,
  moreThanN,
  formatThousandth,
};

export default function installBsFilters(Vue) {
  Object.keys(bsFilters).forEach(item => {
    Vue.filter(item, bsFilters[item]);
  });
}
